<template>
  <div id="chat">
    <!-- eslint-disable  vue/no-v-html -->
    <div
      class="chat text-app-color rounded-8 break-words"
      :class="[
        {'p-20 shadow-message': hasText},
        hasText ? highlighted ? 'bg-text-selection' : 'bg-book' : '',
        classes
      ]"
      v-html="replaceText"
    />
    <div v-if="user.id === message.userId" class="text-grey-300 pt-4 flex items-center leading-none text-15" :class="classes">
      <div class="text-app-color flex items-end">
        <span class="mr-9 text-13 text-grey-300">{{ getTime }}</span>
        <p class="font-semibold">{{ userName }}</p>
      </div>
      <div class="w-3 rounded-2 h-21 ml-10" :style="userColor" />
    </div>
    <div v-else class="text-grey-300 pt-4 flex items-center leading-none text-15">
      <div class="w-3 rounded-2 h-21 mr-10" :style="userColor" />
      <div class="text-app-color flex items-end mr-5">
        <p class="font-semibold">{{ userName }}</p>
        <span class="ml-5 text-12 text-grey-300">{{ getTime }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import userColorMixin from '@/mixins/userColorMixin'
import { parseDate } from '@/plugins/filters'

export default defineComponent({
  props: {
    message: Object,
    classes: [String, Array],
    highlighted: { type: Boolean, default: false }
  },

  setup (props) {
    const { state } = useStore()

    const { userColor } = userColorMixin(props.message?.user?.profile?.color)

    const user = computed(() => state.profile.user)
    const userName = computed(() => {
      const profile = props.message.user?.profile
      return profile ? `${profile.firstName} ${profile.lastName}` : 'Unknown'
    })

    const getTime = computed(() => {
      const today = new Date().getDate()
      const yesterday = today - 1
      const createdAtItem = new Date(props.message.createdAt)
      const getDateCreateAt = createdAtItem.getDate()
      const minute = createdAtItem.getMinutes() < 10 ? '0' + createdAtItem.getMinutes() : createdAtItem.getMinutes()

      if (today === getDateCreateAt) {
        return `${createdAtItem.getHours()}:${minute}`
      }

      if (yesterday === getDateCreateAt) {
        return `Yesterday ${createdAtItem.getHours()}:${minute}`
      } else {
        return parseDate(createdAtItem, 'DD-MM-YYYY hh:mm')
      }
    }).value

    const hasText = computed(() => {
      var span = document.createElement('span')
      span.innerHTML = props.message.text
      return span.textContent.trim() !== '' || span.innerText.trim() !== ''
    })

    const replaceText = computed(() => {
      return props.message.text.replace(/(<br>)+/g, '<br>').replace(/(@)+/g, '')
    })

    return {
      // computed
      user,
      userName,
      getTime,
      hasText,
      replaceText,
      userColor
    }
  }
})
</script>
